var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"marker  throb"},[_c('span',{staticClass:"marker__text"},[_vm._t("default")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917cfab6","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./sportspower/assets/es6/components/MarkerIcon.vue
// module id = 35
// module chunks = 0